import React, { useState, useEffect } from 'react';
import { Typography, Button, Grid } from '@mui/material';
import { Link } from 'react-router-dom';
import PeriodoCard from '../../components/Periodos/PeriodoCard';
import { listarPeriodos } from '../../services/periodoService';

const ListaPeriodosPage = () => {
  const [periodos, setPeriodos] = useState([]);

  useEffect(() => {
    const fetchPeriodos = async () => {
      try {
        const data = await listarPeriodos();
        setPeriodos(data);
      } catch (error) {
        console.error('Erro ao buscar períodos:', error);
        // TODO: Adicionar tratamento de erro e feedback ao usuário
      }
    };

    fetchPeriodos();
  }, []);

  return (
    <div>
      <Typography variant="h4" gutterBottom>
        Períodos
      </Typography>
      <Button
        component={Link}
        to="/periodos/criar"
        variant="contained"
        color="primary"
        sx={{ mb: 2 }}
      >
        Adicionar Novo Período
      </Button>
      <Grid container spacing={3}>
        {periodos.map((periodo) => (
          <Grid item key={periodo.id} xs={12} sm={6} md={4}>
            <PeriodoCard periodo={periodo} />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default ListaPeriodosPage;